import { CommonIcons } from "assets/common/icons";
import { MobileIcons } from "assets/mobile";
import { PATH } from "constants/path";
import { FunctionComponent, SVGProps } from "react";

interface MenuItem {
  label: string;
  icon: FunctionComponent<
    SVGProps<SVGSVGElement> & { title?: string | undefined }
  >;
  to?: string;
}

export const MEMBER_MENU_MOBILE: MenuItem[] = [
  {
    label: "Nạp tiền",
    icon: CommonIcons.Deposit,
    to: PATH.User.Financial,
  },
  {
    label: "Rút tiền",
    icon: CommonIcons.Withdraw,
    to: "/user/financial?open=withdraw",
  },
  {
    label: "Hộp thư đi",
    icon: MobileIcons.Mail,
    to: PATH.User.InternalMail,
  },
  {
    label: "Chi tiết đặt cược",
    icon: MobileIcons.History,
    to: PATH.User.BettingHistory,
  },
  {
    label: "Chi tiết giao dịch",
    icon: MobileIcons.List,
    to: PATH.User.Transactions,
  },
  {
    label: "Khu sự kiện",
    icon: MobileIcons.Event,
    to: PATH.User.Event,
  },
  {
    label: "Yêu thích",
    icon: MobileIcons.Favourite,
    to: PATH.User.FavouriteGame,
  },
  {
    label: "Bảo mật",
    icon: MobileIcons.Security,
    to: PATH.User.SecuritySetting,
  },
  {
    label: "Thông báo",
    icon: MobileIcons.Notification,
    to: PATH.User.Notification,
  },
  {
    label: "Hoàn trả",
    icon: MobileIcons.Refund,
    to: PATH.User.Refund,
  },
  {
    label: "Mật khẩu rút tiền",
    icon: MobileIcons.LockWithdrawIcon,
    to: PATH.User.changePasswordWithdraw,
  },
];
